import { tableStyles } from 'css/tableStyles';
import React, {  useMemo, useState } from 'react';
import DataTable from 'components/DataTable';
import {  showError, showSuccess } from 'utils';
import { Loading } from 'components/loading/Loading';
import DeleteActionForTable from 'components/DeleteActionForTableData';
import ActionButton from 'components/ActionButton';
import styles from './index.module.scss';
import AddInventoryItemModal from 'components/AddInventoryItemModal';
import InventoryItemId from 'components/InventoryItemId';
import { addItemToShoppingList, removeItemFromShoppingList } from 'services/api/shoppingLists';

const ListItems = props => {
  const { items = [], loading, getShoppingListDetailsFn, listId } = props;
  const [addInventoryItemModalOpen, setAddInventoryItemModalOpen] = useState(false);
  const removeItem = async (itemId) => {
    try {
      await removeItemFromShoppingList(itemId, listId);
      showSuccess('Item removed successfully.');
      await getShoppingListDetailsFn();
    } catch (e) {
      showError(e);
    }
  };

  const columns = useMemo(() =>  [
    {
      name: 'ItemID',
      selector: 'objectId',
      sortable: false,
      // eslint-disable-next-line react/display-name
      cell: row => row ? (
        <InventoryItemId itemDetails={row} />
      ): '-',
    },
    {
      name: 'Name',
      selector: 'name',
      sortable: true,
      format: row => row?.name || '-',
    },
    {
      name: 'Action',
      selector: '',
      sortable: true,
      // eslint-disable-next-line react/display-name
      cell: (row: Record<string, any>) => (
        <div className={'ml-3'}>
          <DeleteActionForTable
            onClick={() => removeItem(row?.objectId)}
          />
        </div>
      ),
    },
  ], []);
  
  const toggleModal = () => setAddInventoryItemModalOpen(!addInventoryItemModalOpen);
  
  const addShoppingList = async (params) => {
    const { item } = params;
    try {
      await addItemToShoppingList(item?.id, listId);
      showSuccess('Item added successfully');
      getShoppingListDetailsFn();
      toggleModal();
    } catch (e) {
      showError(e);
    }
  };

  return (
    <div className={styles['inventory-items-container']}>
      {addInventoryItemModalOpen && (
        <AddInventoryItemModal
          shoppingListId={listId}
          onSubmit={addShoppingList}
          toggleModal={toggleModal}
          heading="Add A New Inventory Item"
        />
      )}
      <div className={styles['section-header']}>
        <div className={styles['section-heading']}>List Items</div>
        <ActionButton
          active={true}
          isLoading={false}
          onClick={toggleModal}
          text={<>Inventory Item <span className={'ml-3'}>+</span></>}
        />
      </div>
      {loading && <Loading type={'mini'} />}
      <DataTable
        columns={columns}
        noHeader={true}
        data={items}
        highlightOnHover={true}
        defaultSortField="createdAt"
        customStyles={tableStyles}
        keyField="objectId"
      />
    </div>
  );
};

export default ListItems;